"use strict";

var ubian = ubian || {};
/**
 * card buy related methods
 * @type Object
 */
ubian.transactions = {};

ubian.transactions.init = function () {
  $(".js-download-transactions").click(function (evt) {
    evt.stopPropagation();
    evt.preventDefault();

    var transactionData = {
      from: $(this).data("last"),
      count: $(this).data("limit"),
      lastTicket: $(this).data("last-ticket"),
      companyID: $(this).data("companyid"),
    };

    ubian.transactions.loadMoreTransactions(
      transactionData.from,
      transactionData.count,
      transactionData.lastTicket,
      transactionData.companyID
    );
  });
};

ubian.transactions.loadMoreTransactions = function (
  from,
  count,
  lastTicket,
  companyID
) {
  $.ajax({
    url: ubian.routes["card_ajax_transactions"].replace(800, companyID),
    data: {
      from: from,
      count: count,
      lastTicket: lastTicket,
    },
  }).done(function (res) {
    var txnTable = $("table.transactions");
    var lastRow = txnTable.find("tr:last");
    lastRow.after(res.transactions);
    if (!res.transactions || res.shouldHide) {
      $(".js-download-transactions").fadeOut();
    }
    //update last transaction values
    $(".js-download-transactions").data("last", res.last);
    $(".js-download-transactions").data("last-ticket", res.lastTicket);
  });
};

$(function () {
  ubian.transactions.init();
  if($("#transactionsError").length) {
    ubian.utils.alert(ubian.translate($("#transactionsError").data("errorMessage")));
  }
});
